import type React from 'react'

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <main className="flex min-h-dvh flex-col">
      <div className="flex grow items-center justify-center p-6 lg:rounded-lg lg:bg-white lg:p-10 lg:shadow-xs dark:lg:bg-gray-900">
        {children}
      </div>
    </main>
  )
}
